import { Typography } from 'design-system/src/components/Typography/Typography';
import Hairline from 'design-system/src/components/Hairline/Hairline';
import Button from 'design-system/src/components/Button/Button';
import { PROVIDER_SUPPORT_CONTACT_INFO } from '../../../constants';

/**
 * Footer component for EHR integration instructions with help contact information
 */
export const InstructionsFooter = () => (
  <>
    <Hairline className="!my-8" />
    <Typography weight={700} renderedAs="span">
      Need help?
    </Typography>{' '}
    <Typography renderedAs="span">Email </Typography>
    <Button
      variant="link"
      href={`mailto:${PROVIDER_SUPPORT_CONTACT_INFO.email}`}
      className="!text-purple-700 hover:!text-purple-900"
      textStyledAs="bodyDMSans"
    >
      {PROVIDER_SUPPORT_CONTACT_INFO.email}
    </Button>{' '}
    <Typography renderedAs="span">or call us at {PROVIDER_SUPPORT_CONTACT_INFO.phone}</Typography>
  </>
);
